import React from "react";
import "./App.css";
import "material-react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "material-react-toastify";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Hero from "./sections/Hero";
import Achievements from "./sections/Achievements";
import About from "./sections/About";
import Skills from "./sections/Skills";
import Experience from "./sections/Experience";
import KeyAchievements from "./sections/KeyAchievements";
import Projects from "./sections/Projects";
import Contact from "./sections/Contact";
import SplashCursor from "./components/ui/SplashCursor";
import ProfileCard from "./components/ui/ProfileCard";
import { portfolioData } from "./data/portfolioData";


function App() {
  return (
    <div className="relative min-h-screen overflow-x-hidden bg-slate-950 text-slate-100">
      <SplashCursor />
      <div className="pointer-events-none absolute -left-20 top-24 h-72 w-72 rounded-full bg-cyan-500/10 blur-3xl" />
      <div className="pointer-events-none absolute right-0 top-[28rem] h-80 w-80 rounded-full bg-emerald-500/10 blur-3xl" />
      <Navbar />
      <main className="relative z-10 pt-6">
        <Hero />
        <Achievements />
        <About />
        <Skills />
        <Experience />
        <KeyAchievements />
        <Projects />
        <Contact />
        <section className="pb-16">
          <div className="mx-auto max-w-6xl px-4">
            <ProfileCard
              name={portfolioData.name}
              title={portfolioData.role}
              handle={portfolioData.name.toLowerCase().replace(/\s+/g, "")}
              status="Available for Work"
              contactText="Contact Me"
              avatarUrl="/chetan_jindal.png"
              showUserInfo={true}
              enableTilt={true}
              enableMobileTilt={false}
              onContactClick={() => {
                const node = document.getElementById("contact");
                node?.scrollIntoView({ behavior: "smooth", block: "start" });
              }}
              behindGlowColor="rgba(125, 190, 255, 0.67)"
              behindGlowEnabled={true}
              innerGradient="linear-gradient(145deg,#0f172a 0%,#1e293b 55%,#155e75 100%)"
            />
          </div>
        </section>
      </main>
      <Footer />
      <ToastContainer
        position="top-right"
        autoClose={2500}
        hideProgressBar={false}
        newestOnTop={true}
        pauseOnHover={true}
        theme="dark"
      />
    </div>
  );
}

export default App;
